/* @flow */

/**
 * This function gets the api type from the __typename (i.e. 'Contact' => 'contacts')
 */
export function getApiTypeFromTypename(typename: string) {
    switch (typename) {
        case 'Account':
            return 'accounts';
        case 'Contact':
            return 'contacts';
        case 'Lead':
            return 'leads';
        case 'Origin':
            return 'origins';
        case 'User':
            return 'users';
        default:
            return 'contacts';
    }
}
